import { Install } from "@p0security/integrations-installer";
import type { InstallProps } from "@p0security/integrations-installer";
import { SplunkRegistration } from "@p0security/integrations-splunk-events-shared";
import type { SplunkComponents } from "@p0security/integrations-splunk-events-shared";

import { splunkInstaller } from "./install";

export const Splunk = (
  props: Pick<
    InstallProps<typeof SplunkComponents>,
    "cardOverride" | "onInstall" | "siblings"
  >
) => (
  <Install<typeof SplunkComponents>
    installer={splunkInstaller}
    integration="splunk"
    registration={SplunkRegistration}
    {...props}
  />
);
